export var HOME_USER_LAST_ACTIVITY_TRANSLATION_KEY = 'home-user-learn-last-activity';